import { FC } from "react";
import { CallerEnum, ProductCardProps } from "./product-card.types";
import { TemplateType } from "@commons-monorepo/index";
import { ProductCard1 } from "./skins/product-card-1";
import { ProductCard2 } from "./skins/product-card-2";
import { ProductCard3 } from "./skins/product-card-3";
import { ProductCard4 } from "./skins/product-card-4";
import { ProductCard5 } from "./skins/product-card-5";
import { ProductCard6 } from "./skins/product-card-6";
import { ProductCard7 } from "./skins/product-card-7";

const ProductCard: FC<ProductCardProps> = ({
  product,
  theme,
  currency,
  locale,
  cartProducts,
  addProduct,
  removeProduct,
  manuallyChangeProduct,
  withTags = true,
  storeMetadata,
  caller = CallerEnum.ProductGrid,
}) => {
  const cardType = theme.template.PRODUCT_CARD;

  if (TemplateType.PRODUCT_CARD_1 === cardType)
    return (
      <ProductCard1
        product={product}
        withTags={withTags}
        cartProducts={cartProducts}
        addProduct={addProduct}
        removeProduct={removeProduct}
        manuallyChangeProduct={manuallyChangeProduct}
        locale={locale}
        currency={currency}
        storeMetadata={storeMetadata}
        caller={caller}
      />
    );
  else if (TemplateType.PRODUCT_CARD_2 === cardType)
    return (
      <ProductCard2
        product={product}
        withTags={withTags}
        cartProducts={cartProducts}
        addProduct={addProduct}
        theme={theme}
        removeProduct={removeProduct}
        manuallyChangeProduct={manuallyChangeProduct}
        locale={locale}
        currency={currency}
        storeMetadata={storeMetadata}
        caller={caller}
      />
    );
  else if (TemplateType.PRODUCT_CARD_3 === cardType)
    return (
      <ProductCard3
        product={product}
        withTags={withTags}
        addProduct={addProduct}
        theme={theme}
        cartProducts={cartProducts}
        removeProduct={removeProduct}
        manuallyChangeProduct={manuallyChangeProduct}
        locale={locale}
        currency={currency}
        storeMetadata={storeMetadata}
        caller={caller}
      />
    );
  else if (TemplateType.PRODUCT_CARD_4 === cardType)
    return (
      <ProductCard4
        product={product}
        withTags={withTags}
        addProduct={addProduct}
        theme={theme}
        cartProducts={cartProducts}
        removeProduct={removeProduct}
        manuallyChangeProduct={manuallyChangeProduct}
        locale={locale}
        currency={currency}
        storeMetadata={storeMetadata}
        caller={caller}
      />
    );
  else if (TemplateType.PRODUCT_CARD_5 === cardType)
    return (
      <ProductCard5
        product={product}
        withTags={withTags}
        addProduct={addProduct}
        theme={theme}
        cartProducts={cartProducts}
        removeProduct={removeProduct}
        manuallyChangeProduct={manuallyChangeProduct}
        locale={locale}
        currency={currency}
        storeMetadata={storeMetadata}
        caller={caller}
      />
    );
  else if (TemplateType.PRODUCT_CARD_6 === cardType)
    return (
      <ProductCard6
        product={product}
        withTags={withTags}
        addProduct={addProduct}
        removeProduct={removeProduct}
        manuallyChangeProduct={manuallyChangeProduct}
        cartProducts={cartProducts}
        theme={theme}
        locale={locale}
        currency={currency}
        storeMetadata={storeMetadata}
        caller={caller}
      />
    );
  else if (TemplateType.PRODUCT_CARD_7 === cardType)
    return (
      <ProductCard7
        product={product}
        withTags={withTags}
        addProduct={addProduct}
        removeProduct={removeProduct}
        manuallyChangeProduct={manuallyChangeProduct}
        cartProducts={cartProducts}
        theme={theme}
        locale={locale}
        currency={currency}
        storeMetadata={storeMetadata}
        caller={caller}
      />
    );
  return null;
};

export default ProductCard;
